import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import Layout from '../../../components/global/layout';
import ApiClient from '../../../methods/api/apiClient';
import loader from '../../../methods/loader';
import './style.scss';
import { useSelector } from 'react-redux';
import methodModel from '../../../methods/methods';
import rolesModel from '../../../models/roles.model';
import moment from 'moment';

const BlogViewPage = (p) => {
  const history = useNavigate();
  const user = useSelector((state) => state.user);
  const { id, userId } = useParams();
  const [data, setData] = useState();
  console.log(data?.alt_tag.length, "lggggg")
  const [Permissions, setPermission] = useState({});
  const getDetail = (did) => {
    loader(true);
    ApiClient.get(`blogs`, { id: did }).then((res) => {
      if (res.success) {
        setData(res.data);
      }
      loader(false);
    });
  };

  const back = () => {
    history(-1);
  };

  useEffect(() => {
    getDetail(userId ? userId : id);
  }, [id, userId]);

  return (
    <Layout>
      <div className="pprofile1 shadow-lg">
        <div className="flex items-center mb-8">
          <button
            type="button"
            class="!px-4 bg-[#fff] py-2 flex items-center justify-center  rounded-lg shadow-btn hover:bg-[#F3F2F5] border  transition-all mr-3"
            to="/users"
            onClick={back}
          >
            <i class="fa fa-angle-left text-lg"></i>
          </button>
          <div>
            <h3 className="text-2xl font-semibold text-[#111827]">View Recommended Product</h3>
            <p className="text-sm font-normal text-[#525252]">
              Here you can see all about your Recommended Product
            </p>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Title</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data && methodModel.capitalizeFirstLetter(data?.title)}
            </div>
          </div>
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">URL</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {(data && data?.url) ||
                '--'}
            </div>
          </div>
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Meta Title</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {(data && methodModel.capitalizeFirstLetter(data?.meta_title)) ||
                '--'}
            </div>
          </div>
          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Meta Keyword</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {(data &&
                methodModel.capitalizeFirstLetter(data?.meta_keywords)) ||
                '--'}
            </div>
          </div>

          <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Category</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              {data &&
                methodModel.capitalizeFirstLetter(data?.category_id?.name)}
            </div>
          </div>
          {data?.alt_tag?.length > 0 ? <div className="col-span-12 md:col-span-6">
            <label className="profileheddingcls">Alt Tag</label>

            {data?.alt_tag != "" ? <div className='flex flex-wrap gap-2'>
              {data?.alt_tag?.map((itm) => {
                return (
                  <div className="flex gap-2 items-center border border-[1px] rounded-md bg-[#999] text-[12px] text-[#fff] w-fit py-[4px] px-4">
                    {methodModel.capitalizeFirstLetter(itm) || '--'}
                  </div>
                );
              })}
            </div> :
              <div className="flex gap-2 items-center border border-[1px] rounded-md bg-[#999] text-[12px] text-[#fff] w-fit py-[4px] px-4">
                ---
              </div>}
          </div> : <></>}
          <div className="col-span-12 md:col-span-12">
            <label className="profileheddingcls">Description</label>
            <div className="profiledetailscls bg-[#f5f5f5] px-[10px] py-[8px] min-h-[38px] rounded-md">
              <div dangerouslySetInnerHTML={{ __html: data?.description }}>
                {/* {data && data?.description} */}
              </div>
            </div>
          </div>

          {data?.image ? (
            <div className="col-span-12 md:col-span-12">
              <label className="profileheddingcls">Image</label>
              <div className="flex gap-3 flex-wrap">
                {data?.image?.map((itm) => {
                  return (
                    <div className="imagethumbWrapper">
                      <img
                        src={methodModel.noImg(itm, 'users')}
                        className="thumbnail w-[120px] h-[120px] rounded-lg p-1 shadow-md object-contain"
                      />
                    </div>
                  );
                })}
              </div>
            </div>
          ) : null}
        </div>
      </div>
    </Layout>
  );
};

export default BlogViewPage;
